module.exports = __webpack_public_path__ + "img/title_uk.5e15f242.svg";